import { CampaignLaunchAudience, CampaignLaunchAudienceMatchEnum, MarketingChannel } from "schema"

export type AudienceRuleKind = "segments" | "tags" | "subscribedTo"
export type AudienceRulesMatch =
  (typeof CampaignLaunchAudienceMatchEnum)[keyof typeof CampaignLaunchAudienceMatchEnum]

export type AudienceRuleDraft = { kind: AudienceRuleKind; ids: string[] }

export type AudienceRulesDraft = {
  match: AudienceRulesMatch
  include: AudienceRuleDraft[]
  exclude: AudienceRuleDraft[]
}

export const EMPTY_AUDIENCE_RULES: AudienceRulesDraft = {
  match: CampaignLaunchAudienceMatchEnum.All,
  include: [{ kind: "segments", ids: [] }],
  exclude: [],
}

export function toAudienceSource(draft: AudienceRulesDraft): CampaignLaunchAudience | undefined {
  const include = draft.include.filter((rule) => rule.ids.length).map(toRule)
  if (include.length === 0) return undefined

  return {
    kind: "rules",
    match: draft.match,
    include,
    exclude: draft.exclude.filter((rule) => rule.ids.length).map(toRule),
  }
}

function toRule(rule: AudienceRuleDraft) {
  switch (rule.kind) {
    case "segments":
      return { kind: "segments" as const, segmentIds: rule.ids }
    case "tags":
      return { kind: "tags" as const, tagIds: rule.ids }
    case "subscribedTo":
      return { kind: "subscribedTo" as const, channels: rule.ids as MarketingChannel[] }
  }
}
